<div class="container user-inventory-content">
  <div class="inventory-header">
    <h2>Инвентарь пользователя</h2>
    <button
      *ngIf="canResetInventory"
      mat-raised-button
      color="warn"
      [disabled]="isLoading || isResetting"
      (click)="resetInventory()"
    >
      {{ isResetting ? "Обнуление..." : "Обнулить инвентарь" }}
    </button>
  </div>

  <ng-container *ngIf="userInventory; else loading">
    <div class="total-inventory-sum">
      Стоимость инвентаря:
      <b>
        <span
          matTooltip="{{ totalInventorySum | fastCoinsToDollar }}"
          matTooltipPosition="above"
          [matTooltipDisabled]="!isGoFast"
          >{{ totalInventorySum / 100 | customCurrency }}</span
        >
      </b>
    </div>

    <div class="user-inventory-container">
      <app-market-item
        *ngFor="let item of userInventory"
        [name]="
          item.inventoryItem.baseItem.shortName ||
          item.inventoryItem.baseItem.name
        "
        [weapon]="item.inventoryItem.baseItem.icon"
        [price]="item.inventoryItem.price"
        [color]="item.inventoryItem.baseItem.color"
        [exterior]="item.inventoryItem.baseItem.exterior"
        [skin]="item.inventoryItem.baseItem.skin"
        [statTrak]="item.inventoryItem.baseItem.statTrak"
      >
      </app-market-item>
    </div>
  </ng-container>
</div>

<ng-template #loading>
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</ng-template>
